import React from 'react'
import styled from 'styled-components'
import Link from '../../../../../../components/Link'
import Logo from '../../../../../../images/StolLogo'
import { generatePathByRouteName } from '../../../../../../modules/named-router'

const Wrapper = styled(Link)`
  display: block;
  overflow: hidden;
`

const StyledLogo = styled(Logo)``

const StyledCustomLogo = styled.img``

const StolLogoHeader = ({ img, ...props }) => (
  <Wrapper id="stolLogoWrapper" to={generatePathByRouteName('home')} {...props}>
    {img && <StyledCustomLogo id="stolLogo" src={img} />}
    {!img && <StyledLogo id="stolLogo" />}
  </Wrapper>
)

export default StolLogoHeader
